import React, { useState, useEffect } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Button, Descriptions, Space } from 'antd';
import { PencilFill, TrashFill, Box } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TanksView = function TanksView(_ref) {
  var tankList = _ref.tankList;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        margin: '10px 0px 10px 0px'
      },
      children: /*#__PURE__*/_jsx(Box, {
        size: 45
      })
    }), /*#__PURE__*/_jsx(Row, {
      children: tankList.length > 0 && tankList.map(function (t) {
        return /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 2,
          children: /*#__PURE__*/_jsxs("div", {
            className: "tankBox",
            children: [/*#__PURE__*/_jsx("h5", {
              children: /*#__PURE__*/_jsx("b", {
                children: t.label
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Descriptions, {
              labelStyle: {
                color: '#EEE'
              },
              contentStyle: {
                color: '#EEE'
              },
              title: /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#EEE'
                },
                children: "INFOS CUVE"
              }),
              column: 1,
              children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CAPACITE"
                }),
                children: [t.capacity.toLocaleString('Fr'), " Litre(s)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "DISPONIBLE"
                }),
                children: [t.available_quantity.toLocaleString('Fr'), " Litre(s)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Stock Min."
                }),
                children: [t.red_line.toLocaleString('Fr'), " Litre(s)"]
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: null,
                children: /*#__PURE__*/_jsx(PencilFill, {
                  size: 20
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: null,
                children: /*#__PURE__*/_jsx(TrashFill, {
                  size: 20
                })
              })]
            })]
          })
        }, t.id);
      })
    })]
  });
};
export default TanksView;